import { createApi } from "@reduxjs/toolkit/query/react";
import customBaseQuery from "../../../utils/customBaseQuery";

export const AgendaSearchApi = createApi({
  reducerPath: "AgendaSearchApi",
  baseQuery: customBaseQuery,
  tagTypes: ["agendas"],
  endpoints: (builder) => ({
    postAgendaSearch: builder.query({
      query: (body: any) => {
        return {
          url: `/search/agenda/speaker`,
          method: "POST",
          body: body
        };
      }
    })
  })
});

export const { usePostAgendaSearchQuery } = AgendaSearchApi;
